import React from "react";
import { Outlet } from "react-router-dom";

const PublicRoute = () => {
  // BYPASS AUTH: No authentication checks, always allow access
  return <Outlet />;
};

export default PublicRoute; 
 
